import styled from '@emotion/styled';
import { RadioButton } from '@kompare/kompare-ui-library';
import React, { useId } from 'react';
import { i18n, mediaQuery, TravelInsuranceRangeEnum, TravelInsuranceRangeEnumLabel } from 'src/common';
import { Card, Flex, Text } from 'src/components';
import { onEnterKey } from 'src/common/style/a11y.style';
import { baseWidths, colors } from 'src/theme';

interface BaseCoverageFormProps {
  insuranceRange: TravelInsuranceRangeEnum;
  onInsuranceRangeChange: (insuranceRange: TravelInsuranceRangeEnum) => void;
}

const Container = styled(Card)({
  width: '100%',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  paddingBottom: 8,
  [mediaQuery('laptop')]: {
    width: `${baseWidths.mobile}px`
  },
})

const Fieldset = styled.fieldset({
  border: 0,
  margin: 0,
  padding: 0,
  minWidth: 0,
})

const Legend = styled.legend({
  padding: 0,
  marginBottom: 24,
})

const RadioButtonContainer = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 12
})


export const BaseCoverageForm: React.FC<BaseCoverageFormProps> = ({
  insuranceRange,
  onInsuranceRangeChange
}) => {
  const groupName = useId();

  return (
    <Container padding={24} radius={12}>
      <Flex vertical gap={8}>
        <Text as="h2" type="xLarge" bold color={colors.text1}>
          {i18n.t('components.forms.baseCoverage.title')}
        </Text>
        <Fieldset>
          <Legend>
            <Text as="span" type="small" color={colors.text3}>
              {i18n.t('components.forms.baseCoverage.subtitle')}
            </Text>
          </Legend>
          <RadioButtonContainer>
            {Object.values(TravelInsuranceRangeEnum).map((range) => (
              <RadioButton
                key={range}
                name={groupName}
                value={range}
                label={TravelInsuranceRangeEnumLabel[range]}
                checked={insuranceRange === range}
                onChange={() => onInsuranceRangeChange(range)}
                onKeyDown={onEnterKey(() => onInsuranceRangeChange(range))}
              />
            ))}
          </RadioButtonContainer>
        </Fieldset>
      </Flex>
    </Container>
  );
};
